import { keyframes } from "styled-components";

export const inputMessageKeyframe = keyframes`
from {
  transform: translateY(-10px);
  opacity: 0
}
to {
  transform: translateY(0);
  opacity: 1
}
`;

export const FadeIn = keyframes`
from {
  opacity: 0
}
to {
  opacity: 1
}
`;
